import React, { Fragment } from 'react';

function Error404() {

    return (
        <Fragment>
            <div className='error404'>
                <h1>Error 404!</h1>

                <h2>Página no encontrada</h2>

                <img src="/img/LogoIDN.webp" alt="" />
            </div>
        </Fragment>
    )
}

export default Error404
